import React, { useMemo } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { Route } from '../../components';
import { extractRoutes } from '../../utilities';

const mapItemsAsRoutes = (menuItems: AppRouteSingleType[]) => {
  return menuItems.map(route => {
    if (!route.component) return null;

    const { pageTitle, menuTitle } = route;
    return (
      <Route
        {...route}
        exact
        key={route.url}
        path={route.url}
        title={pageTitle !== false ? pageTitle || menuTitle : ''}
      />
    );
  });
};

const AutoRedirect = () => {
  return <Redirect to="/tasks" />;
};

const Routes: React.FC<{ routes: AppRouteType[] }> = ({ routes }) => {
  const simpleRoutes = useMemo(() => extractRoutes(routes), [routes]);

  return (
    <Switch>
      <Route exact path="/">
        <AutoRedirect />
      </Route>
      {mapItemsAsRoutes(simpleRoutes)}
    </Switch>
  );
};

export default React.memo(Routes) as typeof Routes;
export { getRoutes } from './getRoutes';
